import script from "./StudentAttendanceList.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentAttendanceList.vue?vue&type=script&setup=true&lang=js"

import "./StudentAttendanceList.vue?vue&type=style&index=0&id=0b424c9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b424c9b"]])

export default __exports__